import { createContext } from 'react';

import { PriceInterval, TierStatus } from '@shared/dream-components/src/types';

import type { UpgradeContextType } from './types';

export const UpgradeContext = createContext<UpgradeContextType>({
  email: '',
  setEmail: () => {},
  taxId: '',
  setTaxId: () => {},
  showTaxIdField: false,
  donationAmountCents: 0,
  setDonationAmountCents: () => {},
  selectedTier: {
    id: '',
    name: '',
    description: '',
    prices: [],
    redirect_url: '',
    publication_id: '',
    enabled: false,
    status: TierStatus.ACTIVE,
    discord_access: false,
  },
  setSelectedTier: () => {},
  selectedPrice: {
    id: '',
    amount_cents: 0,
    original_amount_cents: 0,
    currency: '',
    interval: PriceInterval.MONTH,
    denominator: '',
    cta: '',
    features: [],
  },
  setSelectedPrice: () => {},
  selectedGiftTier: undefined,
  setSelectedGiftTier: () => {},
  selectedGiftPrice: undefined,
  setSelectedGiftPrice: () => {},
  isStripeLoading: false,
  stripeSession: null,
  isInternalCheckout: true,
  currentFormMode: 'individual',
  setCurrentFormMode: () => {},
});
